module.exports = __webpack_public_path__ + "static/media/undo-enabled.6cc2321b.svg";